// export const BASE_API = "http://localhost:4000";
export const BASE_API = "https://investigacion.msaludjujuy.gov.ar/api-backend";
